import React from "react";
import SpecialOffer from "../components/Packages/SpecialOffer";
import SpecialOfferBanner from "../components/Packages/SpecialOfferBanner";

const SpecialOfferPage = () => {
  return (
    <>
      <SpecialOfferBanner />
      <SpecialOffer />
    </>
  );
};

export default SpecialOfferPage;
